import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    searchParams: {
        upc: "",
        product: null,
        location: null,
        boilerCode: "",
        quantity: "",
        restQuantity: "",
        unitPrice: ""
    },
}

const rollSlice = createSlice({
    name: 'roll',
    initialState,
    reducers: {
        setRollSearchParamsAction: (state, action) => {
            const { key, value } = action.payload
            state.searchParams = { ...state.searchParams, [key]: value }
        }
    },
});

export const { setRollSearchParamsAction } = rollSlice.actions;
export default rollSlice;